import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Cookies from 'js-cookie'
import elementTwLocale from 'element-ui/lib/locale/lang/zh-CN'
import twLocale from './tw'

import tableMenus from './table';

Vue.prototype.$table = tableMenus;

Vue.use(VueI18n)

const messages = {
  
  tw: {
    ...twLocale,
    ...elementTwLocale
  }
}

const i18n = new VueI18n({
  locale: Cookies.get('language') || 'tw', // set locale
  messages // set locale messages
})

export default i18n
